import clsx from 'clsx';

import { PlatformSection } from '@/common/components';
import { Platforms } from '@/common/constants';
import { usePlatform } from '@/common/hooks';
import { TeamsTable, TeamsTableLegend } from '@/ui/components';

import { PrematchTableType } from '../../constants';
import { usePrematchData } from '../../hooks';
import { mapTableRowsToRowData } from '../../utils/mapTableRowsToRowData';

export default function LeagueView() {
  const { table } = usePrematchData();

  const platform = usePlatform();

  if (!table || table.type !== PrematchTableType.TABLE || !table.tableRows || !table.colorLegend) {
    return null;
  }

  return (
    <div
      className={clsx('flex flex-col gap-3', {
        'pt-6 pb-3 px-3': platform === Platforms.MOBILE,
        'pt-3': platform !== Platforms.MOBILE,
      })}
    >
      <PlatformSection className="overflow-hidden" contentClassName="px-0 pb-0">
        <TeamsTable rowData={mapTableRowsToRowData(table.tableRows)} shouldDisplayFormColumn />
      </PlatformSection>
      <TeamsTableLegend className="p-2" items={table.colorLegend} />
    </div>
  );
}
